export const extractDailyExtremes = liveData => {
	return {
		date: liveData.date,
		highTemperature: liveData.temperature.high.value,
		highTemperatureTime: liveData.temperature.high.time,
		lowTemperature: liveData.temperature.low.value,
		lowTemperatureTime: liveData.temperature.low.time,
		avgTemperature: liveData.temperature.mean,
		highWindGust: liveData.wind.gust.high.value,
		highWindGustTime: liveData.wind.gust.high.time,
		highWindGustBearing: liveData.wind.gust.high.bearing,
		highWindSpeed: liveData.wind.speed.high.value,
		highWindSpeedTime: liveData.wind.speed.high.time,
		windRun: liveData.wind.runToday,
		rainfall: liveData.rainfall.totalToday,
		highRainRate: liveData.rainfall.rate.high.value,
		highRainRateTime: liveData.rainfall.rate.high.time,
		highHourlyRain: liveData.rainfall.hourly.high.value,
		highHourlyRainTime: liveData.rainfall.hourly.high.time,
		highDewpoint: liveData.dewpoint.high.value,
		highDewpointTime: liveData.dewpoint.high.time,
		lowDewpoint: liveData.dewpoint.low.value,
		lowDewpointTime: liveData.dewpoint.low.time,
		highHumidity: liveData.humidity.high.value,
		highHumidityTime: liveData.humidity.high.time,
		lowHumidity: liveData.humidity.low.value,
		lowHumidityTime: liveData.humidity.low.time,
		highPressure: liveData.pressure.high.value,
		highPressureTime: liveData.pressure.high.time,
		lowPressure: liveData.pressure.low.value,
		lowPressureTime: liveData.pressure.low.time
	};
};

export const extractTemperatureSummaryData = liveData => {
	return {
		currentTemperature: liveData.temperature.current,
		temperatureTrend: liveData.temperature.changeLastHour,
		currentDewpoint: liveData.dewpoint.current,
		currentHumidity: liveData.humidity.current,
		highTemperature: liveData.temperature.high.value,
		highTemperatureTime: liveData.temperature.high.time,
		lowTemperature: liveData.temperature.low.value,
		lowTemperatureTime: liveData.temperature.low.time
	};
};

export const extractWindSummaryData = liveData => {
	return {
		liveWindSpeed: liveData.wind.speed.live,
		liveWindBearing: liveData.wind.bearing.live,
		meanWindSpeed: liveData.wind.speed.mean,
		meanWindBearing: liveData.wind.bearing.mean,
		currentWindGust: liveData.wind.gust.current,
		highWindGust: liveData.wind.gust.high.value,
		highWindGustTime: liveData.wind.gust.high.time,
		highWindGustBearing: liveData.wind.gust.high.bearing
	};
};

export const extractRainSummaryData = liveData => {
	return {
		currentRainRate: liveData.rainfall.rate.current,
		currentConditions: liveData.rainfall.rate.description,
		currentHourlyRain: liveData.rainfall.hourly.current,
		rainToday: liveData.rainfall.totalToday,
		rainThisMonth: liveData.rainfall.totalThisMonth,
		rainThisYear: liveData.rainfall.totalThisYear,
		currentPressure: liveData.pressure.current,
		pressureTrend: liveData.pressure.changeLastHour
	};
};



// WEBPACK FOOTER //
// ./utils/live-data.js